module.exports = __webpack_public_path__ + "static/media/29.f92b2800.jpeg";